import { useSelector } from "react-redux";
import { getGridTableRowData } from "../../../../selectors/ileggelseSelector";
import DetaljKommentarer from "../../../Common/Detalj/DetaljKommentarer";
import GridTable from "../../../Common/GridTable";

export default function IleggelseGridOgKommentarContainer() {
  const gridTableRowData = useSelector(getGridTableRowData);
  const ileggelse = useSelector((state) => state.ileggelse);

  return (
    <section>
      <GridTable name="detaljIleggelse" rows={gridTableRowData} />
      <div style={{ paddingLeft: 50, paddingRight: 50 }}>
        <DetaljKommentarer
          internkommentarFraBybetjent={ileggelse.internkommentar}
          kommentarTilMottager={ileggelse.kommentar}
        />
      </div>
    </section>
  );
}
